import React, { Component } from "react";
import moment from "moment";
import { withRouter } from "react-router";
import { sendEvent } from "../../util/utils";
import {STAGE_SHORT, STAGE_COLOR_CODE, STAGE_ICONS} from '../../constants';
import UserService from "../../services/UserService";
import examsService from "../../services/ExamsService";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderList: true,
      windowWidth: window.innerWidth,
    };
    this.userType= UserService.getUserType()
    this.highLightEnable = false;
  }

  componentDidMount() {
    this.userType = UserService.getUserType();
  }

  componentDidUpdate(previousProps) {}

  processName(name) {
    if (name.length > 21) {
      return name.substring(0, 20) + "...";
    } else {
      return name;
    }
  }

  exameName(name) {
    if (this.state.windowWidth < 500 && name.length > 50) {
      return name.substring(0, 45) + "...";
    } else if (name.length > 60) {
      return name.substring(0, 56) + "...";
    }
    return name;
  }

  async getExamResult(exam){

    let year = exam && exam.orderDate.split("-");
    year = year && year.length>0 && year[0];

    if(exam && exam.orderId && exam.examId && year && exam.patientName && exam.examDescription){

      let result = await examsService.getResult(exam.orderId, exam.examId, year);

      if(result){
        const url = window.URL.createObjectURL(new Blob([result]));     
        const downloadLink = document.createElement("a");
        const fileName = `${exam.patientName} - ${exam.examDescription}.pdf`;
    
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    }
  }

  render() {
    const examTextStyle = {
      margin: "0 0 0 0",
    };

    return (
      <>
        {
          (window.onresize = () => {
            this.setState({
              windowWidth: window.innerWidth,
            });
          })
        }
        {this.state.renderList ? (
          <>
            {this.props.exams && this.props.exams.map
              ? this.props.exams.map((exame) => (
                  <div
                    className="exam-container"
                    style={this.userType === 'PSC' ? {gridTemplateRows: "20px auto", height: "101px"}:{}}
                    onMouseOver={() => {
                      if(this.highLightEnable){
                        sendEvent("highlight-exam", exame);
                      }
                    }}
                    onMouseOut={(e) => {
                      this.highLightEnable = true;
                      sendEvent("highlight-exam", null);
                    }}
                    onClick={(e) => {
                      if (e.target.classList.contains("tooltip-date")) {
                        e.stopPropagation();
                        return false;
                      }
                      this.props.getExamHistory(exame);
                    }}
                  >
                    <div className="exam-container-header">
                      <div className="exam-patient">
                        <p style={examTextStyle}
                            data-bs-toggle="tooltip"
                            title={exame.examDescription}>
                          {this.exameName(exame.examDescription)}
                        </p>
                      </div>
                      {exame.urgency && !exame.urgency == "" && (
                        <div className="exam-urgent">Urgente</div>
                      )}
                      {exame.sampleStored.toUpperCase()=="SIM" ? (
                        <div 
                          className='exame-armazenado'
                          data-bs-toggle="tooltip" 
                          title="Exame Armazenado" 
                          data-bs-original-title="Exame armazenado">Armazenado</div>
                      ):(
                        <>
                        {exame.discardedSample && (
                          <div 
                            className='exame-descartado'
                            data-bs-toggle="tooltip" 
                            title={exame.discardedSample}
                            data-bs-original-title={exame.discardedSample}>Descartado</div>
                        )}
                        </>
                      )}
                      {exame.eventStage === "Resultado Liberado" && (
                        <div
                          onClick={(e)=> {
                            e.stopPropagation();
                            this.getExamResult(exame);
                          }}
                          className="exam-report"
                          data-bs-toggle="tooltip"
                          title="Baixar resultado do exame"
                        >Download</div>
                      )}
                    </div>
                    
                    {this.userType !== 'PSC' ?
                      (
                        <div className="detail-section-name">
                          <div className="exam-patient" style={{gridColumn: '2 /span 2'}}>
                            <div className="exam-data-title patient-title">
                              Paciente
                            </div>
                            <div 
                              className="patient-name"
                              data-bs-toggle="tooltip" 
                              title={exame.patientName} 
                              data-bs-original-title={exame.patientName}
                            >
                              {exame.patientName}
                            </div>
                          </div>
                            <div className="exam-number-container">
                              <div className="exam-data-title" style={{fontWeight:'600', overflow: 'hidden'}}>
                                Pedido
                              </div>
                              <div 
                                className="exam-number"
                                data-bs-toggle="tooltip" 
                                title={`${exame.orderId} (${exame.orderAlphaNumeric})`} 
                                data-bs-original-title={`${exame.orderId} (${exame.orderAlphaNumeric})`}
                              >
                                {`${exame.orderId} (${exame.orderAlphaNumeric})`}
                              </div>
                            </div>
                        </div>
                      ):null}
                    
                    <div className="exam-details">
                      
                        <div className="exam-details-unit">
                        <div className="exam-data">
                        <div className="exam-data-title">
                          Unidade
                        </div>
                        <div className="exam-data-date exam-data-content">
                          {exame.aliasProdUnit}
                        </div>
                        </div>
                      </div>
                      <div className="detail-section-previsao"
                      style={this.userType !== 'PSC'? {}: {marginRight:"10%"}}>
                        <div className="exam-data">
                          <div className="exam-data-title">Previsão</div>
                          {!exame.estimatedResultDate ? (
                            <div className="exam-data-date exam-data-content" 
                            >
                              Pendente
                            </div>
                          ) : (
                            <div 
                              class={`exam-data-content ${exame.rescheduled && "exame-remarcado"}`} 
                              data-bs-toggle="tooltip" 
                              title={exame.rescheduled} 
                              data-bs-original-title={exame.rescheduled}
                            >
                              {this.state.windowWidth < 500 ? (
                                <>
                                  {moment(exame.estimatedResultDate).format(
                                    "DD/MM - HH:mm"
                                  )}
                                  <span className="tooltip-text">
                                    {moment(exame.estimatedResultDate).format(
                                      "DD/MM/YYYY - HH:mm"
                                    )}
                                  </span>
                                </>
                              ) : (
                                moment(exame.estimatedResultDate).format(
                                  "DD/MM/YY HH:mm"
                                )
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="detail-section-situacao">
                        <div className="exam-data">
                          <div className="exam-data-title">Situação</div>
                          <div
                            className={
                              "exam-data-content exam-data-status data-status-" +
                              STAGE_ICONS[exame.eventStage.toUpperCase()]
                            }
                            style={{color: STAGE_COLOR_CODE[exame.eventStage.toUpperCase()]}}
                          >
                            {STAGE_SHORT[exame.eventStage.toUpperCase()]}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : null}
          </>
        ) : null}
      </>
    );
  }
}

export default withRouter(List);
